var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.35845 1.01147C2.50956 1.01147 1.01074 2.51029 1.01074 4.35919V13.2864C1.01074 15.1353 2.50956 16.6342 4.35845 16.6342H13.2857C15.1346 16.6342 16.6333 15.1353 16.6333 13.2864V4.35919C16.6333 2.51029 15.1346 1.01147 13.2857 1.01147H4.35845ZM14.2494 4.36404C14.2494 4.89659 13.8176 5.32832 13.2851 5.32832C12.7525 5.32832 12.3208 4.89659 12.3208 4.36404C12.3208 3.83147 12.7525 3.39975 13.2851 3.39975C13.8176 3.39975 14.2494 3.83147 14.2494 4.36404ZM8.82223 6.14836C7.34523 6.14836 6.14787 7.34572 6.14787 8.82273C6.14787 10.2997 7.34523 11.4971 8.82223 11.4971C10.2992 11.4971 11.4966 10.2997 11.4966 8.82273C11.4966 7.34572 10.2992 6.14836 8.82223 6.14836ZM4.86215 8.82273C4.86215 6.63564 6.63514 4.86265 8.82223 4.86265C11.0093 4.86265 12.7823 6.63564 12.7823 8.82273C12.7823 11.0098 11.0093 12.7828 8.82223 12.7828C6.63514 12.7828 4.86215 11.0098 4.86215 8.82273Z",
    fill: "#DB0035"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.c8e960c876365e1497732e56784da64c.svg";
export { ForwardRef as ReactComponent };